var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle3, _circle4, _g, _path12, _path13, _path14, _path15, _path16, _path17, _circle5, _path18, _path19, _circle6, _g2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle7, _circle8, _circle9, _circle0, _circle1, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g3, _rect, _rect2, _path54, _path55, _path56, _path57, _path58, _path59, _circle10, _path60, _path61, _path62, _rect3, _path63, _path64, _path65, _path66, _rect4, _path67, _path68, _path69, _path70, _circle11, _path71, _path72, _path73, _path74, _rect5, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _circle12, _path87, _path88, _rect6, _path89, _path90, _circle13, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 670,
    viewBox: "0 0 439 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 335,
    r: 68,
    fill: "#CCCCD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.265 339.754L195.85 339.754L206.811 368.365L220.698 368.365L235.84 329.092L239.962 318.221L242.62 324.015L250.176 320.64L240.888 300.48L220.46 309.44L223.894 316.907L229.867 314.278L224.193 328.972L214.277 354.776L205.109 329.062L190.176 329.062L190.265 339.754Z",
    fill: "#F2F2F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.667,
    cy: 195.001,
    r: 2.66667,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212 204.334L214.667 200.334H218.667L224 201.667L226.667 204.334L230.667 204.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.667 220.333L224 213.666L218.667 209.666L221.334 201.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.667 212.334L214.667 213.667H206.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212 463.001L213.333 448.334H224L221.333 457.667H228L213.333 477.667L216 463.001H212Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228 471H233.333",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.667 473.666L230.667 468.333",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.334 321.332C347.871 323.465 344.001 328.78 344.001 334.999C344.001 341.217 347.871 346.532 353.334 348.666C351.681 349.311 349.882 349.665 348.001 349.665C339.9 349.665 333.334 343.099 333.334 334.999C333.334 326.899 339.9 320.332 348.001 320.332C349.882 320.332 351.681 320.686 353.334 321.332Z",
    fill: "#CCCCD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.334 321.332L353.819 322.574C354.331 322.374 354.667 321.881 354.667 321.332C354.667 320.783 354.331 320.29 353.819 320.09L353.334 321.332ZM353.334 348.666L353.819 349.908C354.331 349.708 354.667 349.215 354.667 348.666C354.667 348.116 354.331 347.623 353.819 347.424L353.334 348.666ZM345.334 334.999C345.334 329.348 348.85 324.514 353.819 322.574L352.849 320.09C346.891 322.416 342.667 328.213 342.667 334.999H345.334ZM353.819 347.424C348.85 345.483 345.334 340.65 345.334 334.999H342.667C342.667 341.785 346.891 347.581 352.849 349.908L353.819 347.424ZM352.849 347.424C351.348 348.01 349.714 348.332 348.001 348.332V350.999C350.051 350.999 352.014 350.612 353.819 349.908L352.849 347.424ZM348.001 348.332C340.637 348.332 334.667 342.362 334.667 334.999H332.001C332.001 343.835 339.164 350.999 348.001 350.999V348.332ZM334.667 334.999C334.667 327.635 340.637 321.665 348.001 321.665V318.999C339.164 318.999 332.001 326.162 332.001 334.999H334.667ZM348.001 321.665C349.714 321.665 351.348 321.988 352.849 322.574L353.819 320.09C352.014 319.385 350.051 318.999 348.001 318.999V321.665Z",
    fill: "#CCCCD5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M356 336.334V339.001",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M360 325.668V328.335",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M357.333 337.666L354.666 337.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.333 327L358.666 327",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.0016,
    cy: 106.999,
    r: 14.6667,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12938_16584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 91,
    width: 33,
    height: 32
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.001,
    cy: 107,
    r: 16,
    fill: "#CCCCCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12938_16584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2309 131.514C82.5032 137.242 73.2168 137.242 67.4891 131.514C61.7614 125.787 61.7614 116.5 67.4891 110.773C73.2168 105.045 82.5032 105.045 88.2309 110.773C93.9586 116.5 93.9586 125.787 88.2309 131.514Z",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.515 103.229C110.787 108.957 101.501 108.957 95.7732 103.229C90.0455 97.5013 90.0455 88.2149 95.7732 82.4872C101.501 76.7595 110.787 76.7595 116.515 82.4872C122.243 88.2149 122.243 97.5013 116.515 103.229Z",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M317.333 422.999L319.247 419.651C320.77 416.984 318.845 413.666 315.774 413.666H308.226C305.154 413.666 303.229 416.984 304.753 419.651L306.666 422.999",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.001 421.668C306.11 421.668 301.334 426.444 301.334 432.335C301.334 435.98 303.163 439.199 305.953 441.122C306.512 441.508 307.189 441.668 307.868 441.668H316.133C316.812 441.668 317.489 441.508 318.048 441.122C320.839 439.199 322.667 435.98 322.667 432.335C322.667 426.444 317.892 421.668 312.001 421.668Z",
    fill: "#CCCCD5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.048 441.122L318.805 442.22L318.048 441.122ZM302.667 432.335C302.667 427.18 306.846 423.001 312.001 423.001V420.335C305.373 420.335 300.001 425.707 300.001 432.335H302.667ZM306.71 440.025C304.265 438.339 302.667 435.523 302.667 432.335H300.001C300.001 436.437 302.06 440.058 305.196 442.22L306.71 440.025ZM316.133 440.335H307.868V443.001H316.133V440.335ZM321.334 432.335C321.334 435.523 319.736 438.339 317.291 440.025L318.805 442.22C321.941 440.058 324.001 436.437 324.001 432.335H321.334ZM312.001 423.001C317.155 423.001 321.334 427.18 321.334 432.335H324.001C324.001 425.707 318.628 420.335 312.001 420.335V423.001ZM316.133 443.001C317.012 443.001 317.972 442.795 318.805 442.22L317.291 440.025C317.007 440.221 316.613 440.335 316.133 440.335V443.001ZM305.196 442.22C306.03 442.795 306.99 443.001 307.868 443.001V440.335C307.388 440.335 306.994 440.221 306.71 440.025L305.196 442.22Z",
    fill: "#CCCCD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128 243.001L120 256.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132 229.666H140",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124 256.334H116",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 242.999,
    r: 9.33333,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128 242.999L136 229.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128 242.999L136 229.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12938_16584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 232,
    width: 22,
    height: 22
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.001,
    cy: 242.999,
    r: 10.6667,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12938_16584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.001 242.999L136.001 229.666",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.85 428.251C114.174 426.585 113.335 424.403 113.333 422.22C113.331 420.031 114.17 417.841 115.85 416.169C119.204 412.832 124.644 412.832 128 416.169C131.354 412.832 136.794 412.832 140.15 416.169C141.932 417.941 142.767 420.298 142.657 422.617C142.558 424.666 141.722 426.686 140.15 428.251L128 440.333L115.85 428.251Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.667 425.666H124L126.667 421.666L129.334 429.666L132 425.666H133.334",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M316.41 247.088L316.164 246.57C315.305 245.147 314.814 243.207 314.691 241.138C314.446 236.352 316.164 232.6 318.865 232.342H318.988C321.443 232.342 323.653 235.705 324.021 240.362C324.144 242.431 323.898 244.371 323.284 245.924L323.162 246.441H322.671C321.811 246.312 320.707 246.312 319.847 246.441C318.865 246.441 317.883 246.7 317.024 246.958L316.41 247.088Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.579 243.078L307.825 242.561C308.684 241.138 309.175 239.197 309.298 237.128C309.544 232.342 307.825 228.591 305.124 228.332H305.001C302.546 228.332 300.337 231.695 299.968 236.352C299.845 238.421 300.091 240.362 300.705 241.914L300.828 242.431H301.319C302.178 242.302 303.283 242.302 304.142 242.431C305.124 242.431 306.106 242.69 306.966 242.949L307.579 243.078Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M319.356 257.668C317.326 257.668 315.892 255.21 316.012 252.305C316.012 252.082 316.012 251.747 316.012 251.523L316.131 250.965L322.701 251.188V251.747C322.701 251.97 322.701 252.305 322.701 252.529C322.821 255.433 321.268 257.668 319.356 257.668Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.619 253.658C306.65 253.658 308.083 251.2 307.964 248.296C307.964 248.072 307.964 247.737 307.964 247.514L307.844 246.955L301.274 247.179V247.737C301.274 247.96 301.274 248.296 301.274 248.519C301.155 251.424 302.708 253.658 304.619 253.658Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M284 520.334C284 524.752 280.418 536.334 276 536.334C271.582 536.334 268 524.752 268 520.334C268 515.916 271.582 512.334 276 512.334C280.418 512.334 284 515.916 284 520.334Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M278.666 520.333C278.666 521.805 277.472 522.999 276 522.999C274.527 522.999 273.333 521.805 273.333 520.333C273.333 518.86 274.527 517.666 276 517.666C277.472 517.666 278.666 518.86 278.666 520.333Z",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 540.333,
    r: 1.33333,
    fill: "#CCCCD5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 540.333,
    r: 1.33333,
    fill: "#CCCCD5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 540.333,
    r: 1.33333,
    fill: "#CCCCD5"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 540.333,
    r: 1.33333,
    fill: "#CCCCD5"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.002,
    cy: 107.001,
    r: 14.6667,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M356 107C356 111.418 352.418 115 348 115C343.582 115 340 111.418 340 107",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M352 99V103",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M344 99V103",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.665 553.666V577.666H91.9987H77.332V553.666H82.6654V572.333L91.9987 577.666L101.332 572.333V553.666H106.665Z",
    fill: "#CCCCD5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M77.332 553.666V577.666H106.665V553.666H101.332V572.333L91.9987 577.666L82.6654 572.333V553.666H77.332Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.665 548.334L91.9984 553.667L101.332 548.334V572.334L91.9984 577.667L82.665 572.334V548.334Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.999 553.666V577.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M106.668 339.638C106.668 337.088 105.088 324.334 98.5716 324.334C95.8069 324.334 96.0044 331.445 96.0044 335.059C96.0044 341.088 97.1865 345.667 103.903 345.667C106.273 345.667 106.668 342.189 106.668 339.638Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.334 339.638C77.334 337.088 78.9138 324.334 85.4304 324.334C88.195 324.334 87.9976 331.445 87.9976 335.059C87.9976 341.088 86.8155 345.667 80.0986 345.667C77.729 345.667 77.334 342.189 77.334 339.638Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M100 333.667H99.3333C95.2832 333.667 92 330.384 92 326.334V320.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7444 330.197C94.6767 331.39 94.6664 332.592 94.667 333.637C96.0142 334.499 97.6158 334.999 99.3341 334.999H100.001C100.737 334.999 101.334 334.402 101.334 333.666C101.334 332.93 100.737 332.333 100.001 332.333H99.3341C97.4927 332.333 95.845 331.503 94.7444 330.197Z",
    fill: "#F2F2F6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84 333.667H84.6667C88.7168 333.667 92 330.384 92 326.334V320.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2556 330.197C89.3233 331.39 89.3336 332.592 89.333 333.637C87.9858 334.499 86.3842 334.999 84.6659 334.999H83.9992C83.2628 334.999 82.6659 334.402 82.6659 333.666C82.6659 332.93 83.2628 332.333 83.9992 332.333H84.6659C86.5073 332.333 88.155 331.503 89.2556 330.197Z",
    fill: "#F2F2F6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M355.858 563.363L356.61 564.265C357.29 565.08 358.45 565.301 359.382 564.793C360.862 563.985 362.668 565.057 362.668 566.744V575.001C362.668 576.473 361.474 577.667 360.001 577.667H336.001C334.529 577.667 333.335 576.473 333.335 575.001V566.744C333.335 565.057 335.14 563.985 336.621 564.793C337.552 565.301 338.713 565.08 339.392 564.265L340.144 563.363C341.499 561.736 343.959 561.625 345.456 563.122C346.862 564.528 349.141 564.528 350.547 563.122C352.044 561.625 354.503 561.736 355.858 563.363Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M362.668 569.667L360.391 570.908C358.873 571.737 356.975 571.368 355.867 570.039V570.039C354.512 568.413 352.044 568.291 350.547 569.788V569.788C349.141 571.194 346.862 571.194 345.456 569.788V569.788C343.959 568.291 341.491 568.413 340.135 570.039V570.039C339.028 571.368 337.129 571.737 335.611 570.908L333.335 569.667",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M333.334 557.666V574.999C333.334 576.472 334.528 577.666 336.001 577.666H360.001C361.473 577.666 362.667 576.472 362.667 574.999V557.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M351.465 550.334L344.537 554.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M344.537 550.334L351.465 554.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348 548.334V556.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164 128.334C155.899 128.334 149.333 134.9 149.333 143.001C149.333 146.571 150.609 149.844 152.73 152.387C153.201 152.953 153.206 153.793 152.686 154.314L149.814 157.185C149.637 157.363 149.763 157.667 150.014 157.667H163.718C163.728 157.667 163.738 157.666 163.748 157.665C163.832 157.667 163.916 157.667 164 157.667C172.1 157.667 178.666 151.101 178.666 143.001C178.666 134.9 172.1 128.334 164 128.334Z",
    fill: "#CCCCD5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.814 157.185L150.757 158.128L150.757 158.128L149.814 157.185ZM163.748 157.665L163.771 156.332L163.688 156.331L163.605 156.34L163.748 157.665ZM150.666 143.001C150.666 135.637 156.636 129.667 164 129.667V127.001C155.163 127.001 148 134.164 148 143.001H150.666ZM153.754 151.533C151.825 149.221 150.666 146.248 150.666 143.001H148C148 146.895 149.392 150.467 151.706 153.241L153.754 151.533ZM151.743 153.371L148.872 156.243L150.757 158.128L153.629 155.257L151.743 153.371ZM148.872 156.243C147.854 157.26 148.575 159 150.014 159V156.334C150.951 156.334 151.42 157.466 150.757 158.128L148.872 156.243ZM150.014 159H163.718V156.334H150.014V159ZM163.718 159C163.776 159 163.834 158.997 163.891 158.991L163.605 156.34C163.643 156.336 163.68 156.334 163.718 156.334V159ZM164 156.334C163.923 156.334 163.847 156.333 163.771 156.332L163.726 158.998C163.817 159 163.908 159.001 164 159.001V156.334ZM177.333 143.001C177.333 150.364 171.363 156.334 164 156.334V159.001C172.836 159.001 180 151.837 180 143.001H177.333ZM164 129.667C171.363 129.667 177.333 135.637 177.333 143.001H180C180 134.164 172.836 127.001 164 127.001V129.667ZM151.706 153.241C151.735 153.277 151.747 153.318 151.747 153.349C151.746 153.363 151.744 153.37 151.743 153.371C151.743 153.371 151.744 153.37 151.743 153.371L153.629 155.257C154.689 154.196 154.618 152.57 153.754 151.533L151.706 153.241Z",
    fill: "#CCCCD5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M165.916 136.484C165.219 136.702 164.565 137.139 163.999 137.663C163.389 137.139 162.779 136.702 162.081 136.484C159.511 135.698 157.332 138.143 157.332 140.544C157.332 145.084 163.04 149.667 163.999 149.667C164.957 149.667 170.665 145.127 170.665 140.544C170.665 138.143 168.4 135.698 165.916 136.484Z",
    fill: "#F2F2F6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.332 592.334V600.334C209.332 603.28 211.72 605.667 214.665 605.667V605.667C217.611 605.667 219.999 603.28 219.999 600.334V592.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.666 592.334V621.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M230.666 592.334L230.666 621.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M225.332 604.334C225.332 607.28 227.72 609.667 230.665 609.667V592.334C227.72 592.334 225.332 600.334 225.332 604.334Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12938_16584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 62.9993,
    r: 9.33333,
    transform: "rotate(90 220 62.9993)",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.667,
    cy: 62.9993,
    r: 1.33333,
    transform: "rotate(90 234.667 62.9993)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.372,
    cy: 73.3691,
    r: 1.33333,
    transform: "rotate(135 230.372 73.3691)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.37,
    cy: 52.6298,
    r: 1.33333,
    transform: "rotate(45 230.37 52.6298)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 77.6667,
    r: 1.33333,
    transform: "rotate(-180 220 77.6667)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.334,
    cy: 62.9993,
    r: 1.33333,
    transform: "rotate(90 205.334 62.9993)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.63,
    cy: 52.6309,
    r: 1.33333,
    transform: "rotate(135 209.63 52.6309)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.63,
    cy: 73.37,
    r: 1.33333,
    transform: "rotate(45 209.63 73.37)",
    fill: "#CCCCD5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 48.3327,
    r: 1.33333,
    transform: "rotate(-180 220 48.3327)",
    fill: "#CCCCD5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357.334,
    y: 464.334,
    width: 29.3333,
    height: 22.6667,
    rx: 2.66667,
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 357.334,
    y: 464.334,
    width: 29.3333,
    height: 18.6667,
    rx: 2.66667,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M366.667 493.667L368 487",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M377.333 493.667L376 487",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M364 493.666H380",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M362.666 469.666L381.333 477.666",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M381.334 469.666L362.667 477.666",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M149.334 541.666H178.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.667,
    cy: 516.334,
    r: 4,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M160 541.667L160 520.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M153.333 535.001L160 528.334L166.666 535.001",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.667 525.667L160 520.334L165.334 525.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 261.334,
    y: 128.334,
    width: 29.3333,
    height: 29.3333,
    rx: 5.33333,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M276 135L276 137.667",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M285.334 137.666H266.667",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M281.333 137.666V137.666C279.656 143.536 275.295 148.264 269.578 150.408L268 150.999",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M270.667 137.666V137.666C272.344 143.536 276.705 148.264 282.422 150.408L284 150.999",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 357.334,
    y: 181.666,
    width: 29.3333,
    height: 24,
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M366.666 181.667L371.999 176.334L377.333 181.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M367.999 192.334L378.666 205.667H357.333L367.999 192.334Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.664 205.667H386.664L378.664 196.334L374.802 200.84L378.664 205.667Z",
    fill: "#CCCCD5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M386.664 205.667V207.001C387.185 207.001 387.658 206.698 387.875 206.224C388.093 205.751 388.015 205.195 387.676 204.8L386.664 205.667ZM378.664 205.667L377.623 206.5C377.876 206.817 378.259 207.001 378.664 207.001V205.667ZM378.664 196.334L379.676 195.466C379.423 195.171 379.053 195.001 378.664 195.001C378.275 195.001 377.905 195.171 377.651 195.466L378.664 196.334ZM374.802 200.84L373.789 199.972C373.373 200.458 373.36 201.172 373.761 201.673L374.802 200.84ZM386.664 204.334H378.664V207.001H386.664V204.334ZM377.651 197.202L385.651 206.535L387.676 204.8L379.676 195.466L377.651 197.202ZM375.814 201.707L379.676 197.202L377.651 195.466L373.789 199.972L375.814 201.707ZM373.761 201.673L377.623 206.5L379.705 204.834L375.843 200.007L373.761 201.673Z",
    fill: "#CCCCD5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.001,
    cy: 188.333,
    r: 2.66667,
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6667 479C78.6667 483.158 77.4011 486.87 75.4186 489.514C73.4365 492.157 70.7999 493.667 68 493.667C65.2001 493.667 62.5635 492.157 60.5814 489.514C58.5989 486.87 57.3333 483.158 57.3333 479C57.3333 474.842 58.5989 471.13 60.5814 468.486C62.5635 465.843 65.2001 464.333 68 464.333C70.7999 464.333 73.4365 465.843 75.4186 468.486C77.4011 471.13 78.6667 474.842 78.6667 479Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.334 465.666L68.3466 467.312C66.4702 470.439 66.3216 474.308 67.9526 477.57L68.4549 478.574C69.858 481.381 69.9545 484.663 68.7185 487.547L66.6673 492.333",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.666 187H63.9993L71.9993 195H58.666V187Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.666 195H71.9993L63.9993 187H82.666V195Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.334,
    y: 187,
    width: 5.33333,
    height: 8,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M82.666 205.667L53.3327 176.334",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M76 177.666L77.3333 181.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.334 179L82.6673 183",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M308.666 17.0007C308.666 15.5279 307.472 14.334 306 14.334C304.527 14.334 303.333 15.5279 303.333 17.0007",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M298 17.0007C298 15.5279 296.806 14.334 295.334 14.334C293.861 14.334 292.667 15.5279 292.667 17.0007",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M303.333 17V31.6667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M292.667 17V31.6667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M302 22.334H292.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M302 27.666H292.667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M312.667 33.0007L310.391 34.2424C308.872 35.0705 306.974 34.7018 305.866 33.3732V33.3732C304.511 31.7469 302.043 31.6247 300.546 33.1216V33.1216C299.14 34.5276 296.861 34.5276 295.455 33.1216V33.1216C293.958 31.6247 291.49 31.7469 290.134 33.3732V33.3732C289.027 34.7018 287.128 35.0705 285.61 34.2424L283.334 33.0007",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M312.667 39.6667L310.391 40.9084C308.872 41.7365 306.974 41.3679 305.866 40.0392V40.0392C304.511 38.4129 302.043 38.2907 300.546 39.7876V39.7876C299.14 41.1936 296.861 41.1936 295.455 39.7876V39.7876C293.958 38.2907 291.49 38.4129 290.134 40.0392V40.0392C289.027 41.3679 287.128 41.7365 285.61 40.9084L283.334 39.6667",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M127.333 29L156.666 29",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 28.9993,
    r: 9.33333,
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 627.96C141.225 626.865 142.776 626.865 143.231 627.96L146.272 635.271C146.464 635.733 146.898 636.048 147.397 636.088L155.29 636.721C156.472 636.816 156.951 638.291 156.051 639.063L150.037 644.214C149.657 644.539 149.492 645.049 149.608 645.536L151.445 653.238C151.72 654.392 150.465 655.304 149.453 654.685L142.695 650.558C142.269 650.297 141.732 650.297 141.305 650.558L134.548 654.685C133.536 655.304 132.281 654.392 132.556 653.238L134.393 645.536C134.509 645.049 134.343 644.539 133.964 644.214L127.95 639.063C127.049 638.291 127.529 636.816 128.711 636.721L136.604 636.088C137.102 636.048 137.536 635.733 137.728 635.271L140.769 627.96Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M297.692 627.666C296.059 627.666 294.614 628.728 294.127 630.287L292.113 636.732C291.966 637.204 291.891 637.695 291.891 638.19V653.333C291.891 654.008 292.438 654.555 293.113 654.555L304.547 654.556C307.002 654.556 309.16 652.928 309.835 650.567L312.026 642.898C312.807 640.165 310.755 637.445 307.913 637.445L302.358 637.444C301.653 637.444 301.094 636.849 301.138 636.145L301.42 631.634C301.555 629.484 299.847 627.666 297.692 627.666Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 283.333,
    y: 637.445,
    width: 8.55555,
    height: 17.1111,
    rx: 1.22222,
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 382.647V381.667C34.6667 379.089 32.5773 377 30 377V377C27.4227 377 25.3333 379.089 25.3333 381.667V396.333C25.3333 398.911 23.244 401 20.6667 401V401C18.0893 401 16 398.911 16 396.333V395.353",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 389H28.0003",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6667,
    cy: 395.667,
    r: 2.66667,
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 398.333C38.5269 398.333 37.333 397.139 37.333 395.666",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M412 293.002C414.137 288.608 414.227 283.525 411.773 279.276C409.32 275.026 404.873 272.562 399.999 272.217C397.862 276.611 397.772 281.693 400.226 285.943C402.679 290.192 407.126 292.656 412 293.002Z",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M411.999 293L410.8 292.416C410.592 292.845 410.628 293.352 410.894 293.746C411.161 294.141 411.618 294.363 412.093 294.33L411.999 293ZM411.999 279.682L410.822 279.055C410.613 279.447 410.613 279.917 410.822 280.309L411.999 279.682ZM412.225 279.274L411.071 278.607L411.071 278.607L412.225 279.274ZM423.999 272.215L425.198 271.632C424.96 271.142 424.448 270.846 423.905 270.885L423.999 272.215ZM423.773 285.941L424.927 286.607L424.927 286.607L423.773 285.941ZM413.198 293.583C415.431 288.994 415.62 283.641 413.176 279.055L410.822 280.309C412.817 284.051 412.707 288.497 410.8 292.416L413.198 293.583ZM411.071 278.607C410.985 278.755 410.902 278.905 410.822 279.055L413.176 280.309C413.242 280.185 413.31 280.063 413.38 279.941L411.071 278.607ZM423.905 270.885C418.647 271.258 413.773 273.926 411.071 278.607L413.38 279.941C415.585 276.122 419.603 273.863 424.093 273.545L423.905 270.885ZM424.927 286.607C427.63 281.926 427.504 276.371 425.198 271.632L422.8 272.798C424.769 276.846 424.823 281.455 422.618 285.274L424.927 286.607ZM412.093 294.33C417.351 293.957 422.225 291.288 424.927 286.607L422.618 285.274C420.413 289.092 416.395 291.351 411.905 291.67L412.093 294.33Z",
    fill: "#CCCCD5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.001 293.002L412.001 293.001L412 293.002L412.001 293.002ZM412.227 279.276C413.408 277.23 415.05 275.599 416.98 274.418C415.815 272.276 414.1 270.421 412.001 269.002C409.901 270.421 408.186 272.277 407.021 274.419C408.951 275.599 410.593 277.231 411.773 279.276C411.852 279.411 411.927 279.547 412 279.684C412.073 279.547 412.149 279.411 412.227 279.276Z",
    fill: "#CCCCD5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M412.001 293.001L412.748 294.106C413.248 293.768 413.459 293.137 413.262 292.566C413.065 291.996 412.509 291.629 411.907 291.672L412.001 293.001ZM412.001 293.002L411.254 294.107C411.705 294.411 412.296 294.411 412.747 294.107L412.001 293.002ZM412 293.002L411.906 291.672C411.339 291.712 410.86 292.107 410.712 292.657C410.565 293.206 410.783 293.788 411.254 294.106L412 293.002ZM416.98 274.418L417.676 275.555C418.281 275.184 418.49 274.404 418.151 273.781L416.98 274.418ZM412.227 279.276L411.072 278.609L411.072 278.609L412.227 279.276ZM412.001 269.002L412.748 267.897C412.296 267.592 411.705 267.592 411.254 267.897L412.001 269.002ZM407.021 274.419L405.85 273.782C405.511 274.405 405.72 275.185 406.325 275.556L407.021 274.419ZM411.773 279.276L410.619 279.942L410.619 279.942L411.773 279.276ZM412 279.684L410.823 280.311C411.055 280.746 411.507 281.017 412 281.017C412.493 281.017 412.945 280.746 413.177 280.311L412 279.684ZM411.255 291.897L411.254 291.897L412.747 294.107L412.748 294.106L411.255 291.897ZM412.095 294.332L412.096 294.331L411.907 291.672L411.906 291.672L412.095 294.332ZM412.748 291.897L412.747 291.897L411.254 294.106L411.254 294.107L412.748 291.897ZM416.284 273.28C414.173 274.572 412.369 276.362 411.072 278.609L413.381 279.942C414.446 278.098 415.927 276.625 417.676 275.555L416.284 273.28ZM411.254 270.107C413.187 271.413 414.752 273.112 415.809 275.055L418.151 273.781C416.879 271.441 415.013 269.429 412.748 267.897L411.254 270.107ZM408.193 275.055C409.249 273.112 410.814 271.413 412.748 270.107L411.254 267.897C408.988 269.429 407.123 271.441 405.85 273.782L408.193 275.055ZM412.928 278.609C411.631 276.363 409.828 274.573 407.718 273.281L406.325 275.556C408.074 276.626 409.554 278.099 410.619 279.942L412.928 278.609ZM413.177 279.057C413.097 278.907 413.014 278.758 412.928 278.609L410.619 279.942C410.689 280.065 410.757 280.188 410.823 280.311L413.177 279.057ZM411.072 278.609C410.986 278.758 410.903 278.907 410.823 279.057L413.177 280.311C413.243 280.188 413.311 280.065 413.381 279.942L411.072 278.609Z",
    fill: "#CCCCD5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M410.769 375.96C411.225 374.865 412.776 374.865 413.231 375.96L416.272 383.271C416.464 383.733 416.898 384.048 417.397 384.088L425.29 384.721C426.472 384.816 426.951 386.291 426.051 387.063L420.037 392.214C419.657 392.539 419.492 393.049 419.608 393.536L421.445 401.238C421.72 402.392 420.465 403.304 419.453 402.685L412.695 398.558C412.269 398.297 411.732 398.297 411.305 398.558L404.548 402.685C403.536 403.304 402.281 402.392 402.556 401.238L404.393 393.536C404.509 393.049 404.343 392.539 403.964 392.214L397.95 387.063C397.049 386.291 397.529 384.816 398.711 384.721L406.604 384.088C407.102 384.048 407.536 383.733 407.728 383.271L410.769 375.96Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7792 285.888C37.7792 275.666 28.0014 266.333 28.0014 266.333C28.0014 266.333 18.2236 275.666 18.2236 285.888C18.2236 291.288 22.6013 295.666 28.0014 295.666C33.4015 295.666 37.7792 291.288 37.7792 285.888Z",
    fill: "#CCCCD5",
    stroke: "#CCCCD5",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2593 285.889C31.2593 287.689 29.8 289.148 28 289.148",
    stroke: "#F2F2F6",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12938_16584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(236 47) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSidebar);
export default __webpack_public_path__ + "static/media/desktop-sidebar.5ccc8fb4ac57af835f3a50735e94c4a1.svg";
export { ForwardRef as ReactComponent };